import { render, staticRenderFns } from "./LessonNav.vue?vue&type=template&id=7b3548ed&scoped=true"
import script from "./LessonNav.vue?vue&type=script&lang=js"
export * from "./LessonNav.vue?vue&type=script&lang=js"
import style0 from "./LessonNav.vue?vue&type=style&index=0&id=7b3548ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3548ed",
  null
  
)

export default component.exports